module.exports = __webpack_public_path__ + "img/netflix-logo.9243d973.png";